export default {
  getBloques(usuario) {
    return new Promise((resolve, reject) => {
      let ruta = `/api/personas/${usuario.id}/bloques`;
      return axios.get(ruta).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      });
    })
  },
  getBloquesIdUsuario(usuario_id) {
    return new Promise((resolve, reject) => {
      let ruta = `/api/personas/${usuario_id}/bloques`;
      return axios.get(ruta).then((response) => {
        resolve(response.data)
      }, response => {
        resolve(response.data)
      });
    })
  }
}


